import React from 'react';
import { Link } from 'react-router-dom';
export default () => {
  return (
    <div>
    <div className="site-content-body">
      <div className="main_bg_color h-100">
        <div className="container-fluid">
          <div className=" row">
            <div className=" col-lg-4 col-md-12 px-4 mb-5 d-flex gap-4 align-items-center">
                <div className="card card_border w-100">
                  <div className="div_background_color">
                    <h2 className="size_f">NEW<br /> PHOTOSHOOT<br /> REQUEST!</h2>
                  </div>
                  {/* <img class="card-img-top" src="../bootstrap4/img_avatar1.png" alt="Card image" style="width:100%"> */}
                  <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                    <p className="mb-2">Shoot Before: <span>12/28/2022</span></p>
                    <p>Offer Expires: <span>12/26/2022</span></p>
                  </div>
                </div>
             
              <div  style={{borderRight: "7px solid #868B8F", height: 120}}>

                  </div>
            </div>
            <div className="col-lg-4 col-md-12 px-4 mb-5  ">
           
                <Link to={'/photographerjob/detail'}>
                <div>
                  <div className="card card_border div_posetion">
                    <img className="card_img_top" src={require("../../assets/img/just_do_it.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                    <div className="photo_button"><button className="px-4 py-2 rounded-pill">Photo</button></div>
                    <div className=" job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6 text-dark">
                      <p className="mb-2">Company: <span>Nike</span></p>
                      <p>Date of Shoot: <span>12/16/2022</span></p>
                    </div>
                  </div>
                </div>
                </Link>
                
            </div>
            <div className="col-lg-4 col-md-12 px-4 mb-5">
              <div>
                <div className="card card_border div_posetion">
                  <img className="card_img_top" src={require("../../assets/img/job_img_2.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                  <div className="photo_button"><button className="px-4 py-2 rounded-pill">Photo</button></div>
                  <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                    <p className="mb-2">Company: <span>Battleborn</span></p>
                    <p>Date of Shoot: <span>12/19/2022</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 px-4 mb-5">
              <div>
                <div className="card card_border div_posetion">
                  <img className="card_img_top" src={require("../../assets/img/job_mg_24hr.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                  <div className="photo_button"><button className="px-4 py-2 rounded-pill">Photo</button></div>
                  <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                    <p className="mb-2">Company: <span>Nike</span></p>
                    <p>Date of Shoot: <span>12/16/2022</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 px-4 mb-5">
              <div>
                <div className="card card_border div_posetion">
                  <img className="card_img_top" src={require("../../assets/img/spotkeep-logos.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                  <div className="photo_button"><button className="px-4 py-2 rounded-pill">Photo</button></div>
                  <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                    <p className="mb-2">Company: <span>Battleborn</span></p>
                    <p>Date of Shoot: <span>12/19/2022</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 px-4 mb-5">
              <div>
                <div className="card card_border div_posetion">
                  <img className="card_img_top" src={require("../../assets/img/fitness.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                  <div className="photo_button"><button className="px-4 py-2 rounded-pill">Photo</button></div>
                  <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                    <p className="mb-2">Company: <span>Battleborn</span></p>
                    <p>Date of Shoot: <span>12/19/2022</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}
